import { render, staticRenderFns } from "./WarehouseView.vue?vue&type=template&id=1a740504&scoped=true&"
import script from "./WarehouseView.vue?vue&type=script&lang=js&"
export * from "./WarehouseView.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseView.vue?vue&type=style&index=0&id=1a740504&prod&lang=css&"
import style1 from "./WarehouseView.vue?vue&type=style&index=1&id=1a740504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a740504",
  null
  
)

export default component.exports